import React from 'react';
import { Text } from '../Text';

import { DepartmentContainer, Job, JobListings } from './styles';

interface Props {
  title: string;
  availableJobs: OpenJob[];
}

interface OpenJob {
  text: string;
  hostedUrl: string;
}

export function DepartmentBlock({ title, availableJobs }: Props) {
  return availableJobs.length ? (
    <DepartmentContainer data-testid="department-block">
      <Text
        as="h3"
        fontWeight={{ 0: '500' }}
        fontSize={{ 0: '2xl', desktop: '2xl' }}
        colour="defaultText"
        marginBottom="m"
        lineHeight={{ 0: 'l' }}
      >
        {title}
      </Text>
      <JobListings>
        {availableJobs.map((job: OpenJob) => (
          <Job
            key={job.hostedUrl}
            href={job.hostedUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            {job.text}
          </Job>
        ))}
      </JobListings>
    </DepartmentContainer>
  ) : null;
}
